import { queryOptions } from "@tanstack/react-query";

import { request } from "@/lib/request";
import { normalizeRequestError } from "@/lib/errors";
import { Profile } from "@/lib/types";

/**
 * queryOptions factory — the single source of truth for the profiles query.
 *
 * Reference pattern for migrating the rest of src/hooks/queries to v5 queryOptions:
 *   - consume from a hook:        useQuery(profilesQueryOptions())
 *   - prefetch in a route loader: queryClient.ensureQueryData(profilesQueryOptions())
 *   - invalidate type-safely:     queryClient.invalidateQueries({ queryKey: profilesQueryOptions().queryKey })
 *
 * Note: the access-token gate stays in the hook via `enabled` (the queryFn can't call
 * useUser), and the token is intentionally NOT part of the key (logout's queryClient.clear()
 * provides isolation; embedding it only fragments the cache).
 */
export const profilesQueryOptions = () =>
  queryOptions({
    queryKey: ["profiles"] as const,
    queryFn: async (): Promise<Profile[]> => {
      const res = await request
        .get(`/profile`)
        .catch(normalizeRequestError("Something went wrong, please try again."));

      return res.data.data;
    },
  });
